import '../../assets/communicator';
import FormButtonHandler from './util/FormButtonHandler';

import MediumEditor from 'medium-editor';
import 'medium-editor/dist/css/medium-editor.css';

$(function () {

    // form button handler
    new FormButtonHandler(document.body).attach();

    // reload on HTTP 401 Unauthorized (ajaxify)
    $('body').on('imatic.ajaxify.action_complete', function(e) {
        if (401 === e.actionEvent.response.code) {
            window.location.reload();
        }
    });

    // update body class if the page is inside a frame
    let inFrame = false;
    try {
        inFrame = Boolean(window.frameElement || window.parent !== window.top);
    } catch (e) {
        inFrame = true;
    }

    if (inFrame) {
        $('body').addClass('embedded');
    }
});

window.MediumEditor = MediumEditor;
